import { Wb360Viewer } from '@workbench/react';

function Exterior360View({ images }) {
	return (
		<Wb360Viewer
			preloadHighResImages
			images={images.map((image) => ({
				lowRes: { src: image },
				highRes: { src: image },
			}))}
		/>
	);
}

export default Exterior360View;
